import { decodeBoatClass } from '@/network/decoders'
import { Defaults, Options } from '@/orm/models/Setting'
import SettingsRepo from '@/orm/repositories/SettingsRepo'
import { AxiosRepository } from '@pinia-orm/axios'
import BoatClass from '@/orm/models/BoatClass'
import { useRepo } from 'pinia-orm'

export default class BoatClassesRepo extends AxiosRepository<BoatClass> {
    use = BoatClass

    classesList(event = null, used = false) {
        let list = this.all()

        let eventClasses = null

        if (event !== null) {
            eventClasses = new Map(
                event.classes.map((eventClass) => [eventClass.boatClassId, eventClass.eventClassName]),
            )

            list = list.filter((boatClass) => (used ? eventClasses.has(boatClass.id) : !eventClasses.has(boatClass.id)))
        }

        return list.map((boatClass) => ({
            label: eventClasses !== null ? (eventClasses.get(boatClass.id) ?? boatClass.name) : boatClass.name,
            shortcut: boatClass.shortcut,
            code: boatClass.id,
            value: boatClass.id,
        }))
            .sort((a, b) => a.label.localeCompare(b.label))
    }

    update() {
        const authToken = useRepo(SettingsRepo).getOption(Options.AuthToken, Defaults.AuthToken)

        this.flush()

        return this.api().get('/catalogs/classes', {
            headers: { Authorization: authToken.length > 0 ? 'Bearer ' + authToken : '' },
            dataTransformer: ({ data }) => {
                return data.map((line) => ({
                    id: decodeBoatClass(line.id),
                    name: String(line.name),
                    shortcut: String(line.shortcut),
                    flag: (Object.hasOwn(line, 'flag') && line.flag !== null) ? String(line.flag) : undefined,
                    crewSize: Object.hasOwn(line, 'crewSize') ? parseInt(line.crewSize) : undefined,
                    scoringSystem: Object.hasOwn(line, 'scoringSystem') ? String(line.scoringSystem) : 'A',
                    useBoatNames: Object.hasOwn(line, 'useBoatNames') ? Boolean(line.useBoatNames) : false,
                    useHandicaps: Object.hasOwn(line, 'useHandicaps') ? Boolean(line.useHandicaps) : false,
                    canBeRenamed: Object.hasOwn(line, 'canBeRenamed') ? Boolean(line.canBeRenamed) : false,
                    intClassId: Object.hasOwn(line, 'intClassId') ? String(line.intClassId) : undefined,
                }))
            },
        })
    }
}
